import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import JobService from "services/jobAd";
import Utils from "utils";
import Constants from "app_constants";
import HomeView from "./view";

class Home extends Component {
  state = {
    jobs: [],
    jobPublishedModal: false,
    paymentModal: false,
    registerModal: false,
    page: 0,
    searchValue: "",
    messageBox: false,
    loaded: false,
    showFilters: false,
    filters: {
      worldwide: false,
      compensation: false,
    },
    isGrid: false,
    category: null,
  };

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const jobPublished = params.get("jobPublished");
    const paymentCompleted = params.get("paymentCompleted");
    const registered = params.get("registered");

    if (jobPublished) this.setState({ jobPublishedModal: true });
    if (paymentCompleted) this.setState({ paymentModal: true });
    if (registered) this.setState({ registerModal: true });

    this.getJobs();

    setTimeout(() => {
      this.setState({ messageBox: true });
    }, 1500);
  }

  getJobs = () => {
    JobService.getJobs(this.state.page).then((res) => {
      if (res) {
        this.setState({ jobs: this.state.jobs.concat(res), loaded: true });
      }
    });
  };

  showJobPublishedModal = (value) =>
    this.setState({ jobPublishedModal: value });

  showPaymentModal = (value) => this.setState({ paymentModal: value });

  showRegisterModal = (value) => this.setState({ registerModal: value });

  getJobsByCategory = (category) => {
    JobService.getJobsByCategory(category, this.state.page).then((res) => {
      if (res) {
        this.setState({ jobs: this.state.jobs.concat(res), loaded: true });
      }
    });
  };

  paginate = () => {
    const { category } = this.state;

    this.setState({ page: this.state.page + 1 }, () => {
      if (category) {
        this.getJobsByCategory(category);
      } else {
        this.getJobs();
      }
    });
  };

  setSearchValue = (searchValue) => this.setState({ searchValue });

  search = () => {
    const { searchValue } = this.state;
    const { history } = this.props;

    if (Utils.validator(searchValue))
      history.push(`/search-results?value=${searchValue}`);
  };

  closeMessageBox = () => this.setState({ messageBox: false });

  publishJobAd = () => {
    const { user, history } = this.props;

    if (user.id && user.type === "company") history.push("/publish-job");
    else history.push("/login");
  };

  updateFilter = (key, value) => {
    const { filters } = this.state;
    this.setState({ filters: { ...filters, [key]: value } });
  };

  selectCategory = (category) => {
    window.scrollTo(0, 0);
    this.setState({ category, jobs: [], page: 0, loaded: false }, () => {
      if (category) {
        this.getJobsByCategory(category);
      } else this.getJobs();
    });
  };

  toggleFilters = () => this.setState({ showFilters: !this.state.showFilters });

  toggleGrid = () => this.setState({ isGrid: !this.state.isGrid });

  handleKeyDown = (event) => {
    if (event.key === Constants.enterKey) this.search();
  };

  render() {
    const {
      jobs,
      jobPublishedModal,
      paymentModal,
      registerModal,
      messageBox,
      loaded,
      filters,
      showFilters,
      isGrid,
      category,
    } = this.state;
    return (
      <HomeView
        jobs={jobs}
        jobPublishedModal={jobPublishedModal}
        showJobPublishedModal={this.showJobPublishedModal}
        paymentModal={paymentModal}
        showPaymentModal={this.showPaymentModal}
        paginate={this.paginate}
        registerModal={registerModal}
        showRegisterModal={this.showRegisterModal}
        setSearchValue={this.setSearchValue}
        search={this.search}
        messageBox={messageBox}
        closeMessageBox={this.closeMessageBox}
        publishJobAd={this.publishJobAd}
        loaded={loaded}
        filters={filters}
        updateFilter={this.updateFilter}
        showFilters={showFilters}
        toggleFilters={this.toggleFilters}
        toggleGrid={this.toggleGrid}
        isGrid={isGrid}
        handleKeyDown={this.handleKeyDown}
        selectCategory={this.selectCategory}
        category={category}
      />
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));
